import React, {useEffect, useState} from 'react';
import {IFilters} from '../../../../../util/userData';
import {BtnPopover} from '../../../BtnPopover';
import {QuestionsDataSource} from '../../DataSources';
import {IFiltersBarState} from '../../index';

interface IQuestion {
    label: string
    value: string
}

type IUpdateFiltersCallback = <K extends keyof IFilters, J extends keyof IFiltersBarState>(filterKey: K, stateKey: J, value: IFiltersBarState[J], forceUpdate?: boolean, keepValueAsAnArray?: boolean) => void;

interface IMultiQuestionsFilterComponentProps {
    onUpdateFilters?: IUpdateFiltersCallback;
}

export const MultiQuestionsFilterComponent: React.FC<IMultiQuestionsFilterComponentProps> = ({ onUpdateFilters }) => {
    const [questions, setQuestions] = useState<IQuestion[]>([]);
    const [hasLoaded, setHasLoaded] = useState(false);
    const [selectedQuestions, setSelectedQuestions] = useState<string[]>([])

    useEffect(() => {
        // Subscribe to updates
        const unsubscribe = QuestionsDataSource.onSync(({ records }) => {
            setQuestions(records.map((record) => {
                return {label: record.label ? record.label : '', value: record.value }
            }));
            setHasLoaded(true);
        });

        // Fetch data
        QuestionsDataSource.sync();

        // Cleanup listener on unmount
        return () => unsubscribe();
    }, []);

    useEffect(() => {
        onUpdateFilters('listOfQuestions', 'listOfQuestions', selectedQuestions, true, true);
    }, [selectedQuestions]);

    return (
        <div style={{marginRight: '15px'}}>
            <BtnPopover header="Question" showSpinner={!hasLoaded} popoverContentClasses="bg-white">
                {questions.map((question) => {
                    const isQuestionSelected = selectedQuestions.includes(question.value);
                    return (
                        <p key={question.value} style={{minWidth: '250px', cursor: 'pointer'}} onClick={() => {
                            if (isQuestionSelected) {
                                setSelectedQuestions(selectedQuestions.filter((value) => value !== question.value))
                            } else {
                                setSelectedQuestions([...selectedQuestions, question.value])
                            }
                        }}><i
                            className={(isQuestionSelected ? 'fas fa-check-square' : 'far fa-square')}
                        ></i>&nbsp;{question.label}</p>
                    );
                })}
            </BtnPopover>
        </div>
    );
};
